const KpiInformation = () => import('@/views/pages/kpiCatalog/kpiInformation/index.vue');
const KpiDetail = () => import('@/views/pages/myworkspace/kpiDetail/index.vue');
const basicDimension = () => import('@/views/pages/kpiCatalog/basicDimension/index.vue');
const basicDimensionDetail = () => import('@/views/pages/kpiCatalog/basicDimension/detail.vue');
const DataStandards = () => import('@/views/pages/dataStandard/standards/index.vue');

const FoundationalModal = () => import('@/views/pages/dataStandard/standards/components/foundationalModal/index.vue');
const businessGlossaryDetail = () =>
  import('@/views/pages/dataStandard/standards/components/businessGlossary/detail.vue');

const DataStandardRouteList = [
  {
    path: 'kpiInformation',
    component: KpiInformation,
    name: '/kpiInformation',
    meta: {
      ownType: 'dataStandards',
      lableTitle: 'KPI Lib',
      mid: '5d1f-8e49',
    },
  },
  {
    path: 'referenceDataLib',
    component: basicDimension,
    name: '/referenceDataLib',
    meta: {
      ownType: 'dataStandards',
      lableTitle: 'Reference Data Lib',
      mid: '0c7a-b6d2',
    },
  },
  {
    path: 'referenceDataDetail',
    component: basicDimensionDetail,
    name: '/referenceDataDetail',
    meta: {
      ownType: 'dataStandards',
      lableTitle: 'Reference Data Detail',
      mid: '9e84-5f13',
    },
  },
  {
    path: 'foundational',
    component: DataStandards,
    name: '/foundational',
    meta: {
      ownType: 'dataStandards',
      lableTitle: 'Foundational Data Standards Lib',
      mid: 'f3b2-6a8d',
    },
  },
  {
    path: 'businessGlossaryDetail',
    component: businessGlossaryDetail,
    name: '/businessGlossaryDetail',
    meta: {
      ownType: 'dataStandards',
      lableTitle: 'Business Glossary',
      mid: '4d07-e9c1',
    },
  },
  {
    path: 'businessGlossary',
    component: DataStandards,
    name: '/businessGlossary',
    meta: {
      ownType: 'dataStandards',
      lableTitle: 'Business Glossary',
      mid: 'a6b5-8d2f',
    },
  },
  {
    path: 'kpiCatalogDetail',
    component: KpiDetail,
    name: '/kpiCatalogDetail',
    meta: {
      ownType: 'dataStandards',
      lableTitle: 'KPI Lib',
      mid: '1c9e-4f70',
    },
  },
  {
    path: 'foundationalDetail',
    component: FoundationalModal,
    name: '/foundationalDetail',
    meta: {
      ownType: 'dataStandards',
      lableTitle: 'Foundational Data Standards',
      mid: 'e2d8-5a3b',
    },
  },
];
export default DataStandardRouteList;
